import script from "./PricingView.vue?vue&type=script&setup=true&lang=js"
export * from "./PricingView.vue?vue&type=script&setup=true&lang=js"

import "./PricingView.vue?vue&type=style&index=0&id=39f4e8b0&lang=css"

const __exports__ = script;

export default __exports__